import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/LegalPages.css';

const MentionsLegales = () => {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>{t('legal.title')}</h1>

        <section className="legal-section">
          <h2>{t('legal.editorTitle')}</h2>
          <p><strong>{t('legal.siteName')}:</strong> Main2Main</p>
          <p><strong>{t('legal.url')}:</strong> https://main2main.ch</p>
          <p><strong>{t('legal.legalForm')}:</strong> {t('legal.legalFormValue')}</p>
          <p><strong>{t('legal.owner')}:</strong> {t('legal.ownerValue')}</p>
          <p><strong>{t('legal.address')}:</strong> {t('legal.addressValue')}</p>
          <p><strong>{t('legal.email')}:</strong> info@main2main.ch</p>
        </section>

<section className="legal-section">
          <h2>{t('legal.activityTitle')}</h2>
          <p>{t('legal.activityDescription')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.intellectualPropertyTitle')}</h2>
          <p>{t('legal.intellectualPropertyText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.liabilityTitle')}</h2>
          <p>{t('legal.liabilityText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.applicableLawTitle')}</h2>
          <p>{t('legal.applicableLawText')}</p>
        </section>

        <section className="legal-section">
          <h2>{t('legal.contactTitle')}</h2>
          <p>{t('legal.contactText')}</p>
          <p><strong>{t('legal.email')}:</strong> info@main2main.ch</p>
        </section>
      </div>
    </div>
  );
};

export default MentionsLegales;
